import CommonTNTBillingBase from '../../../util/CommonTNTBillingBase';
import _ from 'lodash';

const surchargeTypes = ['INSURANCE', 'FUEL', 'SECURITY', 'LIABILITY'];

class CustomerBaseController extends CommonTNTBillingBase {
  /*@ngInject*/
  constructor(Auth, $state, User, Service, Modal, $translate, $stateParams) {

    super(Auth, $state, User, Service, Modal, $translate, $stateParams)

    this.errors = {}
    this.loading = false
    this.errorMessage = ''
    this.model = {}
    this.id = 'customer'

    this.surchargeTypeList = surchargeTypes;
    this.surchargeLabelKeys = {
      INSURANCE: 'customer.surcharge_insurance',
      FUEL: 'customer.surcharge_fuel',
      SECURITY: 'customer.surcharge_security',
      LIABILITY: 'customer.surcharge_liability'
    };

    this.intervalOptions = [
      { label: this.$translate.instant('customer.surcharge_interval_weekly'), value: 'WEEKLY' },
      { label: this.$translate.instant('customer.surcharge_interval_bi_weekly'), value: 'BI_WEEKLY' },
      { label: this.$translate.instant('customer.surcharge_interval_monthly'), value: 'MONTHLY' },
      { label: this.$translate.instant('customer.surcharge_interval_quarterly'), value: 'QUARTERLY' }
    ];

    this.billingEventPageLimit = 100;
  }

  buildDefaultSurcharges() {
    const surcharges = {};
    surchargeTypes.forEach((type) => {
      surcharges[type] = {
        enabled: false,
        percentage: null,
        interval: null,
        billingEventOptions: [],
        billingEvents: []
      };
    });
    return surcharges;
  }

  getBillingEventOptions() {
    const fetchPage = (offset, accumulated) => {
      return this.BillableEventsService.all(null, offset, this.billingEventPageLimit)
        .then((data) => {
          const merged = accumulated.concat(data.results);
          return merged.length < data.total ? fetchPage(offset + this.billingEventPageLimit, merged) : merged;
        });
    };

    return fetchPage(0, [])
      .then((results) => {
        const options = results.map((event) => ({
          id: event.id,
          label: this.$translate.instant(`entry_type.${event.type}`),
          value: event.type
        }));
        return _.sortBy(options, ['label', 'ASC']);
      });
  }

  applySurchargeOptions(surcharges, billingEventOptions) {
    surchargeTypes.forEach((type) => {
      surcharges[type].billingEventOptions = _.cloneDeep(billingEventOptions);
    });
  }

  applySurchargeData(surcharges, customerDetail) {
    if (!customerDetail) return;

    const surchargeBillingEvents = customerDetail.surchargeBillingEvents || {};

    surchargeTypes.forEach((type) => {
      const prefix = type.toLowerCase();
      const percentage = customerDetail[`${prefix}Percentage`];
      const billableEventIds = surchargeBillingEvents[type] || [];

      surcharges[type].enabled = !!customerDetail[`${prefix}Enabled`];
      surcharges[type].percentage = percentage !== null && percentage !== undefined ? percentage : null;
      surcharges[type].interval = customerDetail[`${prefix}Interval`];
      surcharges[type].billingEventOptions.forEach((option) => {
        option.ticked = billableEventIds.includes(option.id);
      });
    });
  }

  mapSurchargesForSubmit(surcharges) {
    const customerFields = {};
    const surchargeBillingEvents = {};

    surchargeTypes.forEach((type) => {
      const surcharge = surcharges[type];
      const prefix = type.toLowerCase();

      customerFields[`${prefix}Enabled`] = !!surcharge.enabled;
      customerFields[`${prefix}Percentage`] = surcharge.enabled ? this.convertSurchargePercentage(surcharge.percentage) : null;
      customerFields[`${prefix}Interval`] = surcharge.enabled ? surcharge.interval : null;
      surchargeBillingEvents[type] = surcharge.enabled ? (surcharge.billingEvents || []).map((event) => event.id) : [];
    });

    return { customerFields, surchargeBillingEvents };
  }

  convertSurchargePercentage(value) {
    if (!value && value !== 0) return null;
    return Number(String(value).replace('%', ''));
  }

  surchargeBillingEventsMissing(surcharges) {
    return surchargeTypes.some((type) => surcharges[type].enabled && (surcharges[type].billingEvents || []).length === 0);
  }

  blockNonNumericKeypress($event) {
    const charCode = $event.which || $event.keyCode;
    const isDigit = charCode >= 48 && charCode <= 57;
    const isDot = charCode === 46;

    if (!isDigit && !isDot) {
      $event.preventDefault();
      return;
    }

    if (isDot && String($event.target.value || '').includes('.')) $event.preventDefault(); // only one dot
  }

  reset() {
    // for (let key in this.model) {
    //   this.model[key] = ''
    // }
    //this.clearErrors()
  }
  askCreate() {
    this.Modal.confirm({
      header: this.$translate.instant(this.id + '.create_another_title'),
      message: this.$translate.instant(this.id + '.create_another_message'),
      callback: ({
        modal,
        $scope
      }) => {
        this.reset()
        modal.close()
      },
      negative: ({
        modal,
        $scope
      }) => {
        modal.close()
        window.history.go(-1)
      },
      type: 'primary',
      buttons: ['common.yes', 'common.no']
    })
  }

  validate() {
    this.clearErrors()
    // for (let key in this.model) {
    //   if (!this.model[key]) {
    //     this.addError(key, key.charAt(0).toUpperCase() + key.slice(1) + ' is mandatory')
    //   }
    // }
    return Object.keys(this.errors).length <= 0
  }

  clearErrors() {
    this.errors = {}
    this.errorMessage = ''
  }

  addError(id, message) {
    this.errors[id] = message
  }
}

export default CustomerBaseController;



// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/customer/common/customer.base.controller.js